angular
    .module("accordionUploadDocumentsEstero.components", [])
    .component("accordionUploadDocumentsEstero", {
        templateUrl: "ng/components/accordionUploadDocumentsEstero/accordionUploadDocumentsEstero.view.html",
        bindings: {
            userDaCensire: "=",
            enabledSave: "&",
            appIlTransaction: "<",
            isIntegration: "<",
            goBackModal: "&",
            isDigital: '<',
            financialModel: '<',
            snapshot: '<',
            portalRunned: '<',
            postVenditaModel: '=',
            isPostVendita: '<',
            elencoListaEntiRilascio: '<'
        },
        controllerAs: "uploadDocumentsEsteroCtrl",
        controller: function accordionUploadDocuments(
            $configService,
            $rootScope,
            $timeout,
            $typeDomainService,
            Documento,
            $modalService,
            $scope,
            validationService,
            Pf,
            $download,
            $userService,
            HttpService,
            EnteRilascio,
            $portalService,
            $istatService
        ) {
            var self = this;
            var getStati = function () {

                self.listaNomiStatiNascita = $rootScope.nazioniEstere.filter(x => x.description != '086' && x.description != '139' && x.description != 'T86');
                self.listaNomiStatiResidenza = self.listaNomiStatiNascita.filter(x => !x.deleted);
                self.listaNomiStatiRilascio = self.listaNomiStatiResidenza;
                self.listStatiRilascio = self.listaNomiStatiNascita.map(x => x.name);

            };

            self.$onInit = (function () {
                self.refreshDocRegex = true;
                self.testDati = {
                    value: true,
                    error: ""
                }
                self.cfAziendaleIsRequired = false;
                self.enteRilascioModel = "";
                self.disabledForUploadingInProgress = false;
                self.disabeldUploadFront = false;
                self.disabeldUploadBack = false;
                self.disabeldUploadCfFront = false;
                self.disabeldUploadCfBack = false;
                self.disabledFirmatarioTitolare = false;
                self.ilTransaction = 0;
                self.dealerUser = {};
                self.showLoader = false;
                self.base64 = null;
                self.link = "";
                self.progress = 0;
                self.frontBase64 = "";
                self.backBase64 = "";
                self.disabledInputCf = false;
                self.disabledInputDoc = false;
                self.mapComuni = $rootScope.comuniMap;
                self.comuniNsilSoppressi = $rootScope.mapComuniSoppressi;
                self.currentCodeTypeNameIndex = 0;
                self.listaProvince = [];
                self.listaProvinceRilascio = [];
                self.listaNomeComuniRilascio = [];
                self.listaNomeComuniNascita = [];
                self.listaNomiStatiNascita = [];
                self.listaNomiStatiResidenza = [];
                self.listaNomeComuniResidenza = [];
                self.listaCap = [];
                self.yesterday = moment().add(-1, "days").format("DD/MM/YYYY");
                self.today = moment().format("DD/MM/YYYY");
                self.tomorrow = moment()
                    .add(1, "days")
                    .format("DD/MM/YYYY");
                self.userDaCensire = self.userDaCensire | {};
                self.documentUpload = [];
                self.enabledModifyDocumentDate = false;
                self.currentSlide = 0;
                self.userDaCensire = {
                    titolare: {
                        selected: false
                    },
                    firmatario: {
                        selected: false
                    }
                };
                Object.assign(self.userDaCensire, {
                    titolare: {
                        selected: false
                    },
                    firmatario: {
                        selected: false
                    }
                });

                self.dropdown = {
                    ruolo: [],
                    stati: [],
                    comune: [],
                    statiEsteri: [],
                    entiRilascio: [],
                    tipiDocumento: [],
                    tipoGarante: []
                };
                self.validationObj = {
                    documentDate: {
                        disabledDays: [0],
                        disabledDates: [
                            "01-01",
                            "06-01",
                            "25-04",
                            "01-05",
                            "02-06",
                            "15-08",
                            "01-11",
                            "08-12",
                            "25-12",
                            "26-12"
                        ]
                    },
                    regex: {
                        documentNumber: /.+/
                    }
                };

                //albaInit();
                getStati();


                self.listaProvince = self.mapComuni
                    .map(function (comune) {
                        return comune.sigla;
                    })
                    .filter(function (siglaComune) {
                        return siglaComune != "";
                    })
                    .sort()
                    .reduce(function (result, nextItem) {
                        return result.includes(nextItem) ? result : result.concat(nextItem);
                    }, []);
                self.listaProvince.push("EE");
                self.listaProvinceRilascio = self.listaProvince;

                self.creaComuniRilascio = function (provincia) {
                    self.listaNomeComuniRilascio = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });

                    self.userDaCensire.documento.luogoEsteso = "";
                    if ((provincia == 'BZ' || provincia == 'TN') && self.userDaCensire.documento.tipo == 'CAI') {
                        self.regExpDocumento = 'CAIBZTN';
                    } else {
                        self.regExpDocumento = self.userDaCensire.documento.tipo
                    }

                    self.refreshDocRegex = false;
                    $timeout(function () {
                        self.refreshDocRegex = true;
                    }, 200)
                };

                self.creaComuniNascita = function (provincia) {
                    self.listaNomeComuniNascita = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });
                    self.userDaCensire.datiNascita.luogoEsteso = "";
                    self.verifyDate();
                };

                self.creaComuniResidenza = function (provincia, check) {
                    if (!check) {
                        self.userDaCensire.residenza.cap = "";
                        self.userDaCensire.residenza.indirizzo = "";
                        self.userDaCensire.residenza.numeroCivico = "";
                        self.userDaCensire.residenza.comune = "";
                        self.userDaCensire.residenza.luogoEsteso = "";
                        if (provincia != "EE") {
                            self.userDaCensire.residenza.stato = Stato.build();
                        } else {
                            self.userDaCensire.residenza.stato = "";
                        }
                    }

                    if (provincia == "EE") {
                        self.isForeign = true;
                        return;
                    } else {
                        self.isForeign = false;
                    }
                    self.listaNomeComuniResidenza = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });


                };

                self.creaCap = function (comune, chiamataDalRest) {

                    if (!chiamataDalRest) {
                        self.userDaCensire.residenza.cap = "";
                    }

                    if (comune.cap && comune.cap.length > 0) {
                        self.listaCap = comune.cap;

                    } else {
                        if (self.listaNomeComuniResidenza.length > 0 && comune.nome) {
                            var tempComune = self.listaNomeComuniResidenza
                                .find(function (element) {
                                    return element.nome.toUpperCase() == comune.nome.toUpperCase();
                                });

                            self.listaCap = tempComune && tempComune.cap;
                        }



                    }

                    self.userDaCensire.residenza.comune = comune && comune.nome

                };
                //getRuoli();
                $typeDomainService
                    .getRoles()
                    .then(function (response) {
                        self.dropdown.ruolo = response;
                    })
                    .catch(function (err) {
                        $rootScope.$broadcast("addAlert", {
                            text: "ERROR_NEXT"
                        });
                    });
                $typeDomainService
                    .getDomainSet("GARANTE", "ROLE")
                    .then(function (response) {
                        self.dropdown.tipoGarante = response.domainList && response.domainList
                            .map(function (element) {
                                return element.value
                            });
                    });
                $timeout(function () {
                    if ($portalService.isAra()) {
                        self.unlockDocumentFields = true;
                    } else {
                        self.unlockDocumentFields = false;
                    }
                    if (self.userDaCensire.isEstero && self.userDaCensire.datiNascita.stato.name && self.userDaCensire.datiNascita.stato.name.toUpperCase() === 'ITALIA') {
                        self.userDaCensire.datiNascita.stato = ""
                    }
                    self.userDaCensire.documento.enteRilascio = Documento.getEntiRilascio(self.userDaCensire.documento.tipo)[0]
                    self.enteRilascioModel = self.userDaCensire.documento.enteRilascio;
                    if (self.userDaCensire.documento.imgDocumentoCfFront) {
                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoCfFront,
                            type: "imgCf",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoCfBack,
                            type: "imgCf",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoFront,
                            type: "imgDocument",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoBack,
                            type: "imgDocument",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);
                        self.userDaCensire.isOk = false;

                        self.indexDocument = 0;
                        self.disabeldUploadCfFront = true;
                        self.disabeldUploadCfBack = true;
                        self.unlockDocumentFields = true;
                    }
                    if (!self.userDaCensire.documento.imgDocumentoFront && !self.userDaCensire.documento.imgDocumentoBack && $portalService.isAru() && !self.userDaCensire.isEstero) {

                        self.userDaCensire.documento.tipo = "";

                    } else {
                        self.disabeldUploadFront = true;
                        self.disabeldUploadBack = true;
                    }
                    if (!self.userDaCensire.documento.idImgDocumentoFrontOther && !self.userDaCensire.documento.idImgDocumentoBackOther) {
                        self.userDaCensire.ulterioreDocumento.tipo = ""
                    }
                    if (self.userDaCensire.documento.tipo) {
                        self.enabledModifyDocumentDate = true;
                        self.regExpDocumento = self.userDaCensire.documento.tipo;
                        if ((self.userDaCensire.documento.provincia == 'BZ' || self.userDaCensire.documento.provincia == 'TN') && self.userDaCensire.documento.tipo == 'CAI') {
                            self.regExpDocumento = 'CAIBZTN';
                        }
                    }

                    if (self.userDaCensire.documento.provincia == 'SE' || self.userDaCensire.documento.provincia == 'EE') {

                        if (self.userDaCensire.documento.luogo) {
                            self.userDaCensire.documento.statoEsteso = self.listaNomiStatiRilascio.find(x => {
                                return x.name.toUpperCase() == self.userDaCensire.documento.luogo.toUpperCase()
                            })

                            self.userDaCensire.documento.stato = self.userDaCensire.documento.statoEsteso.name;
                        }
                        if (!self.userDaCensire.documento.luogo && self.userDaCensire.documento.luogoEsteso && self.userDaCensire.documento.luogoEsteso.nome) {
                            self.userDaCensire.documento.statoEsteso = self.listaNomiStatiRilascio.find(x => {
                                return x.name.toUpperCase() == self.userDaCensire.documento.luogoEsteso.nome.toUpperCase()
                            })

                            self.userDaCensire.documento.stato = self.userDaCensire.documento.statoEsteso.name;
                        }

                    }
                    self.disabledUploadDocument();
                    //initCarousel();
                    dealerUser();

                    self.ilTransaction = self.isDigital ? 0 : self.appIlTransaction.id;

                    self.listaNomeRilascio = getEntiRilascio(
                        self.userDaCensire.documento.tipo
                    );

                    if (self.userDaCensire.residenza.provincia == "EE") {
                        self.isForeign = true;
                    } else {
                        self.isForeign = false;
                    }
                    if (self.userDaCensire.residenza.luogoEsteso.nome == "") {

                        self.userDaCensire.residenza.luogoEsteso = "";

                    }
                    if (self.userDaCensire.datiNascita.luogoEsteso.nome == "") {

                        self.userDaCensire.datiNascita.luogoEsteso = "";

                    }
                    if (self.userDaCensire.documento.luogoEsteso.nome == "") {

                        self.userDaCensire.documento.luogoEsteso = "";
                    }
                    if (self.userDaCensire.residenza.provincia) {
                        self.userDaCensire.residenza.luogoEsteso = {
                            nome: self.userDaCensire.residenza.comune

                        }
                        self.creaComuniResidenza(self.userDaCensire.residenza.provincia, true);
                    }
                    if (self.userDaCensire.datiNascita.luogoEsteso.nome == "" && self.userDaCensire.datiNascita.provincia) {
                        self.creaComuniNascita(self.userDaCensire.datiNascita.provincia);
                    }
                    if (self.userDaCensire.documento.luogoEsteso.nome == "" && self.userDaCensire.documento.provincia) {
                        self.creaComuniRilascio(self.userDaCensire.documento.provincia);
                    }
                    if (self.isDigital) {
                        self.disabledFirmatarioIsCustomer = false;
                    }
                    if (self.userDaCensire.residenza.luogoEsteso.nome) {
                        self.creaCap(self.userDaCensire.residenza.luogoEsteso, true);
                    }
                    if (self.financialModel && getWizardMap(self.financialModel.viewIndex) == "M17") {
                        self.isM17Map = true;

                    } else {
                        self.isM17Map = false;
                    }
                    if (self.financialModel && getWizardMap(self.financialModel.viewIndex) == "M15") {
                        self.isM15Map = true;

                    } else {
                        self.isM15Map = false;
                    }
                    if (self.financialModel && self.financialModel.leasingData && self.financialModel.leasingData.preventivo && self.financialModel.leasingData.preventivo.firmaDigitale && !self.financialModel.leasingData.preventivo.firmaDigitaleEsterna
                    ) {
                        self.enablePhone = true;
                    } else {
                        self.enablePhone = false;
                    }
                }, 1);

                self.typePerson = $configService.getUser().type
                if (self.typePerson === 'ASSOCIATE_PERSON' || self.typePerson === 'SIGNER') {
                    self.disabeldPep = true;
                    self.disabledFirmatarioTitolare = true;
                    self.userDaCensire.titolare = {
                        pep: {
                            selected: "N"
                        }
                    }

                } else {


                    self.disabledFirmatarioIsCustomer = true;

                }

                self.linkPep = '/uni/download/service-infos/' + encodeURIComponent('GLOSSARIO') + '/';

                //RN:12378303
                self.userDaCensire.firmatario.spid = 'N';    

            })(
                (self.loadingStatus = {
                    uploading: false,
                    loadingDataFromCerved: false,
                    savedDataFromCerved: false,
                    loading: false,
                    loadingAddressesList: false,
                    loadingPfList: false,
                    insertingContract: false
                })
            );

            self.downloadInfoPep = () => {

                $download.getGenericDownload(self.linkPep)
                    .then(function (response) {
                        console.log(response);
                    })
            }




            self.check = function (el) {
                el.selected = !el.selected;
                if (!self.userDaCensire.firmatario.selected) {
                    self.userDaCensire.firmatario.ruolo = "";
                    self.userDaCensire.email = "";
                } else if (!self.userDaCensire.titolare.selected) {
                    self.userDaCensire.titolare.pep = "N";
                }



            };


            self.enabledTrashRemovePdf = function () {
                return self.documentUpload.some(function (element) {
                    return element.selected === true;
                });
            };

            self.leastDocumentUpload = function () {
                var ritorno = false;

                ritorno = self.documentUpload.some(function (element) {
                    return element.type === "imgDocument" && element.name;
                });
                return ritorno;
            };

            self.leastDocumentCfUpload = function () {
                var ritorno = false;
                ritorno = self.documentUpload.some(function (element) {
                    return element.type === "imgCf";
                });
                return ritorno;
            };

            self.enteRilascioSelezionato = function (ente) {
                if (self.userDaCensire.documento.tipo === "PAT") {
                    if (ente === "MINISTERO") {
                        self.regExpDocumento = "UCO";
                    } else if (ente === "DIPARTIM. TRASPORTI TERRESTI") {
                        self.regExpDocumento = "PAM";
                    } else if (ente === "PREFETTURA") {
                        self.regExpDocumento = "PAT";
                    }
                }
                console.log(ente);
                self.userDaCensire.documento.enteRilascio = {
                    name: ente
                };
            };

            self.listaEntiRilascio = function (preserveData) {
                if (preserveData) {
                    return;
                }
                /*                 self.userDaCensire.documento.imgDocumentoFront = "";
                                self.userDaCensire.documento.imgDocumentoBack = ""; */

                self.enabledModifyDocumentDate = true;
                self.documentUpload = self.documentUpload.filter(function (element) {
                    return element.type != "imgDocument";
                });
                self.disabledUploadDocument();
            };

            self.savePfData = function (pf) {
                console.log(pf);
                pf.isOk = true;
                self.modalShow = false;
                pf.documento.enteRilascio = EnteRilascio.build(self.enteRilascioModel);
                pf = Pf.build(pf);
                self.enabledSave({
                    Pf: pf
                });
            };
            self.undoDocumentChanges = function (pf) {
                if (self.isIntegration === true || self.validateForm()) {
                    pf.isOk = true;
                    $("#footerInstant").css("z-index", "2");
                    $('.financial-leasing__footer').css("z-index", "2");
                    jQuery('.mCSB_scrollTools').css("z-index", "2");
                } else {
                    pf.isOk = false;
                    $("#footerInstant").css("z-index", "2");
                    $('.financial-leasing__footer').css("z-index", "2");
                    jQuery('.mCSB_scrollTools').css("z-index", "2");
                    self.enabledSave({
                        Pf: pf
                    });
                }
                self.goBackModal && self.goBackModal();

            };

            self.getEndDate = function (dataRilascio) {
                if (dataRilascio) {
                    var tipoDocumento = self.userDaCensire.documento.tipo;
                    var dataNascita = self.userDaCensire.datiNascita.data || moment(dataRilascio, "DD/MM/YYYY");
                    var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
                    var startYear = moment(dataRilascio).format("YYYY");
                    var startDay = moment(dataRilascio).format("DD");
                    var startMonth = moment(dataRilascio).format("MM");

                    var endDate = moment(dataRilascio)
                        .add(10, "years")
                        .format("DD/MM/YYYY");

                    if (
                        tipoDocumento === propMap["DOC_TYPE_CAI"] ||
                        tipoDocumento === propMap["DOC_TYPE_NCE"] ||
                        tipoDocumento === propMap["DOC_TYPE_CIE"] ||
                        tipoDocumento === propMap["DOC_TYPE_CAE"] ||
                        tipoDocumento === propMap["DOC_TYPE_PAT"] ||
                        tipoDocumento === propMap['DOC_TYPE_PAM'] ||
                        tipoDocumento === propMap['DOC_TYPE_UCO'] ||
                        self.isM17Map
                    ) {
                        var dataNascita = moment(dataNascita, "DD/MM/YYYY");
                        var birthYear = moment(dataNascita).format("YYYY");
                        var birthDay = moment(dataNascita).format("DD");
                        var birthMonth = moment(dataNascita).format("MM");

                        if (birthMonth == '02' && birthDay == '29') {
                            birthMonth = '03';
                            birthDay = '01';
                        }

                        var futureBirthDay = moment(
                            birthDay + "/" + birthMonth + "/" + startYear,
                            "DD/MM/YYYY"
                        )
                            .add(10, "years")
                            .format("DD/MM/YYYY");
                        //console.log("Compleanno Futuro: " + futureBirthDay);

                        var daysDiff = moment
                            .duration(
                                moment(endDate, "DD/MM/YYYY").diff(
                                    moment(futureBirthDay, "DD/MM/YYYY")
                                )
                            )
                            .asDays();

                        var expiryDate;
                        if (daysDiff <= 0) {
                            expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
                                "DD/MM/YYYY"
                            );
                        } else {
                            expiryDate = moment(
                                birthDay + "/" + birthMonth + "/" + startYear,
                                "DD/MM/YYYY"
                            )
                                .add(11, "years")
                                .format("DD/MM/YYYY");
                        }

                        while (
                            (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
                            ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]))) {
                            expiryDate = moment(
                                expiryDate,
                                "DD/MM/YYYY"
                            )
                                .add(10, "years")
                                .format("DD/MM/YYYY");
                        }

                        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
                        expiryDate = moment(expiryDate, "DD/MM/YYYY")
                            .add(2, "years")
                            .add(3, "months")
                            .format("DD/MM/YYYY");
                        //fine campo aggiunto per emergenza COVID19

                        if ($scope.pfForm && $scope.pfForm.dataScadenza && moment.duration(moment(self.userDaCensire.documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0) {
                            $scope.pfForm.dataScadenza.$valid = false;
                        }
                        if ($scope.pfForm && $scope.pfForm.dataScadenza && moment.duration(moment(self.userDaCensire.documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2) {
                            $scope.pfForm.dataScadenza.$valid = false;
                            $scope.pfForm.dataScadenza.$setValidity("dataScadenza", false);
                        } else {
                            $scope.pfForm && $scope.pfForm.dataScadenza && $scope.pfForm.dataScadenza.$setValidity("dataScadenza", true);
                        }
                        return expiryDate;
                    } else {
                        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
                        endDate = moment(endDate, "DD/MM/YYYY")
                            .add(2, "years")
                            .add(3, "months")
                            .format("DD/MM/YYYY");
                        //fine campo aggiunto per emergenza COVID19
                        if (
                            moment
                                .duration(
                                    moment(
                                        self.userDaCensire.documento.dataScadenza,
                                        "DD/MM/YYYY"
                                    ).diff(moment(endDate, "DD/MM/YYYY"))
                                )
                                .asDays() > 0
                        ) {
                            $scope.pfForm.dataScadenza.$valid = false;
                        }
                        return endDate;
                    }
                } else {
                    return moment(self.today, "DD/MM/YYYY")
                        .add(10, "years")
                        .format("DD/MM/YYYY");
                }

            };

            self.validateForm = function () {
                showMissingData();
                self.allDocumentUploaded = checkFilesUpload();
                var check = self.userDaCensire.firmatario.selected;
                if ($portalService.isAra()) {

                    self.userDaCensire.documentiCaricati = true;
                    self.allDocumentUploaded = true;

                }
                if (self.userDaCensire.residenza.provincia != "EE" && self.userDaCensire.residenza.provincia != "SE") {
                    if (check) {
                        if (self.userDaCensire.garante.selected) {

                            return $scope.pfForm.$valid &&
                                self.userDaCensire.sesso &&
                                self.userDaCensire.firmatario.ruolo &&
                                self.userDaCensire.residenza.cap &&
                                self.userDaCensire.residenza.luogoEsteso.nome &&
                                self.allDocumentUploaded &&
                                !!self.userDaCensire.documento.tipo &&
                                (self.userDaCensire.titolare.pep != 'Y' || self.isDigital) &&
                                (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                        } else {
                            return $scope.pfForm.$valid &&
                                self.userDaCensire.sesso &&
                                self.userDaCensire.firmatario.ruolo &&
                                self.userDaCensire.residenza.cap &&
                                self.userDaCensire.residenza.luogoEsteso.nome &&
                                self.allDocumentUploaded &&
                                !!self.userDaCensire.documento.tipo &&
                                (self.userDaCensire.titolare.pep != 'Y' || self.isDigital) &&
                                (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)
                        }

                    } else if (!check && !self.userDaCensire.garante.selected) {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.sesso &&
                            self.userDaCensire.residenza.cap &&
                            self.userDaCensire.residenza.luogoEsteso.nome &&
                            self.allDocumentUploaded &&
                            !!self.userDaCensire.documento.tipo &&
                            (self.userDaCensire.titolare.pep != 'Y' || self.isDigital) &&
                            (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                    } else {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.sesso &&
                            self.userDaCensire.residenza.cap &&
                            self.userDaCensire.residenza.luogoEsteso.nome &&
                            self.allDocumentUploaded &&
                            !!self.userDaCensire.documento.tipo &&
                            (self.userDaCensire.titolare.pep != 'Y' || self.isDigital)

                    }
                } else {
                    if (check) {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.sesso &&
                            self.userDaCensire.firmatario.ruolo &&
                            self.allDocumentUploaded &&
                            self.userDaCensire.residenza.stato &&
                            !!self.userDaCensire.documento.tipo &&
                            (self.userDaCensire.titolare.pep != 'Y' || self.isDigital) &&
                            (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                    } else if (!check && !self.userDaCensire.garante.selected) {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.sesso &&
                            self.allDocumentUploaded &&
                            self.userDaCensire.residenza.stato &&
                            !!self.userDaCensire.documento.tipo &&
                            (self.userDaCensire.titolare.pep != 'Y' || self.isDigital) &&
                            (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                    } else {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.sesso &&
                            self.userDaCensire.residenza.cap &&
                            self.userDaCensire.residenza.comune &&
                            self.allDocumentUploaded &&
                            !!self.userDaCensire.documento.tipo

                    }
                }

            };

            self.getTodaysDate = function () {
                return moment().format("DD/MM/YYYY");
            };
            self.getTomorrowDate = function () {
                return moment().add(1, "days").format("DD/MM/YYYY");
            };


            self.verifyDate = function () {
                self.testDati.value = true;
                var codCat;
                if (self.userDaCensire && self.userDaCensire.datiNascita &&
                    self.userDaCensire.datiNascita.luogoEsteso &&
                    self.userDaCensire.datiNascita.luogoEsteso.nome) {
                    var comuniCompleti = self.mapComuni.concat(self.comuniNsilSoppressi);
                    var tempCodCat = comuniCompleti
                        .filter(function (element) {
                            return element.nome.toUpperCase() == self.userDaCensire.datiNascita.luogoEsteso.nome.toUpperCase()
                        })[0].codiceCatastale;
                    codCat = self.userDaCensire.datiNascita.luogoEsteso.codiceCatastale ? self.userDaCensire.datiNascita.luogoEsteso.codiceCatastale : tempCodCat;
                } else if (self.userDaCensire && self.userDaCensire.datiNascita && self.userDaCensire.datiNascita.stato.name) {
                    codCat = self.userDaCensire.datiNascita.stato.value;
                }
                if (!codCat) {
                    self.testDati.value = false;
                    return;
                }

                self.testDati = validationService.checkCfWithFieds(
                    self.userDaCensire.cf,
                    self.userDaCensire.nome,
                    self.userDaCensire.cognome,
                    self.userDaCensire.datiNascita.data,
                    self.userDaCensire.sesso,
                    codCat
                );

                if (!self.testDati.value) {
                    if (typeof $scope.pfForm.userCf != "undefined") {
                        $scope.pfForm.userCf.$setValidity("userCf", false);
                    }
                } else {
                    if (typeof $scope.pfForm.userCf != "undefined") {
                        $scope.pfForm.userCf.$setValidity("userCf", true);
                    }
                }

            };

            self.disabledUploadDocument = function () {
                if (self.uploadDocumenti === "imgCf") {
                    self.uploadCfCompleted = false;
                } else {
                    self.uploadDocCompleted = false;
                    self.frontBase64 = "";
                    self.backBase64 = "";
                }
                self.disabledUploadCf = self.documentUpload.some(function (elem) {
                    return elem.type === "imgCf";
                });

                var temp = 0;

                self.documentUpload.forEach(function (elem) {
                    if (elem.type === "imgDocument") {
                        temp++;
                    }

                    if (temp >= 2) {
                        self.disabledUploadDocIdent = true;
                    } else {
                        self.disabledUploadDocIdent = false;
                    }
                });
            };

            var dealerUser = function () {
                if ($portalService.isAru()) {

                    $userService.getDealerUser()
                        .then(function (dealer) {
                            if (dealer) {
                                self.dealerUser = dealer;
                            }
                        });
                }
            }


            self.$onDestroy = function () {
                clearInterval(self.intervalOfRepeatListenMobileCapture);

                $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE"
                });
            }


            /* Parte da eliminare */

            self.getFromDomain = function (table, value, list, delay, cb) {
                $timeout(function () {
                    HttpService.send('/uni/typedomain/getDomainSet', {
                        table: table,
                        column: value
                    }, false)
                        .then(function (response) {
                            if (list) {
                                self.dropdown[list] = response.domainList;
                            }

                            if (cb) {
                                cb(response);
                            }
                        });
                }, delay);
            }


            self.getFromDomain('RI_DROPDOWN_DOMAINS', 'DOCUMENT_TYPE', 'tipiDocumento', 20, function () {

                for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
                    if (self.dropdown.tipiDocumento[i].value == "CAE") {
                        self.dropdown.tipiDocumento[i].order = 40;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "CAI") {
                        self.dropdown.tipiDocumento[i].order = 10;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "CIE") {
                        self.dropdown.tipiDocumento[i].order = 20;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "NCE") {
                        self.dropdown.tipiDocumento[i].order = 30;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAM") {
                        self.dropdown.tipiDocumento[i].order = 50;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAS") {
                        self.dropdown.tipiDocumento[i].order = 80;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAT") {
                        self.dropdown.tipiDocumento[i].order = 60;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "UCO") {
                        self.dropdown.tipiDocumento[i].order = 70;
                    }

                    self.dropdown.tipiDocumento = self.dropdown.tipiDocumento
                        .filter(function (element) {
                            return element.value != "CAE"
                        })

                }


            });

            self.setDocNumRegex = function (tipoDocumento, fromUploadFinish) {
                console.log(tipoDocumento);
                if (!fromUploadFinish) {
                    self.userDaCensire.documento = Documento.build({ idImgDocumentoCfFront: self.userDaCensire.documento.idImgDocumentoCfFront, imgDocumentoCfFront: self.userDaCensire.documento.idImgDocumentoCfFront })
                }
                self.regExpDocumento = tipoDocumento;
                self.listaNomeRilascio = getEntiRilascio(tipoDocumento);

                // if (tipoDocumento == 'PAS' || tipoDocumento == 'CAE') {
                //     var testIfPresent = self.listaProvinceRilascio.findIndex(function (element) {
                //         return element == 'EE'
                //     })
                //     if (testIfPresent < 0) {
                //         self.listaProvinceRilascio.push('EE');
                //     }
                // } else {
                //     self.listaProvinceRilascio = self.listaProvinceRilascio.filter(function (element) {
                //         return element != 'EE'

                //     });

                // }

                if (tipoDocumento == 'CAE') {
                    self.userDaCensire.documento.provincia = 'EE';
                    self.disabledProvRilascioEstera = true;
                } else {
                    self.userDaCensire.documento.provincia = null;
                    self.disabledProvRilascioEstera = false;
                }

                if (tipoDocumento == 'UCO' && $portalService.isAru()) {
                    self.ucoDocumentSelected = true;
                    self.userDaCensire.documento.provincia = 'RM';
                    var roma = self.mapComuni
                        .find(function (comune) {
                            return comune.nome.toLowerCase() == 'roma';
                        });
                    self.userDaCensire.documento.luogoEsteso = roma;
                    self.setLuogo('documento', roma)
                } else {
                    self.ucoDocumentSelected = false;
                }
                self.listaEntiRilascio();
                self.userDaCensire.documento.tipo = tipoDocumento;
                self.enteRilascioSelezionato(self.listaNomeRilascio[0].name);
                self.enteRilascioModel = self.listaNomeRilascio[0];

                self.documentUpload = self.documentUpload.filter(function (element) {
                    return element.type != 'imgDocument'
                });
                self.disabeldUploadBack = false;
                self.disabeldUploadFront = false;
            }


            self.uploadFinish = function (fromChangeDoc) {
                self.creaComuniResidenza(self.userDaCensire.residenza.provincia, true);
                self.creaCap(self.userDaCensire.residenza.luogoEsteso, true);
                self.unlockDocumentFields = true;
                if (fromChangeDoc) {
                    self.setDocNumRegex(self.userDaCensire.documento.tipo);
                } else {
                    self.setDocNumRegex(self.userDaCensire.documento.tipo, true);
                }
            }


            var getWizardMap = function (viewIndex) {
                return $rootScope.wizardMap
                    .find(function (element) {
                        return element.index == viewIndex
                    }).viewName
            }



            self.upgradeListaComuni = function (value) {
                if (self.userDaCensire.documento.provincia) {
                    self.creaComuniRilascio(self.userDaCensire.documento.provincia);
                }
                self.userDaCensire.documento.luogoEsteso = {
                    nome: value
                }
            }

            var checkFilesUpload = function () {
                var test = false
                if (self.userDaCensire.numDocumenti == 1 || self.userDaCensire.numDocumenti == 2) {

                    test = self.userDaCensire.documento.uploadedDoc && self.userDaCensire.documento.uploadedDoc.length > 0;

                } else if (self.userDaCensire.numDocumenti == 4) {

                    test = !!self.userDaCensire.documento.imgDocumentoCfBack &&
                        !!self.userDaCensire.documento.imgDocumentoCfFront &&
                        !!self.userDaCensire.documento.imgDocumentoBack &&
                        !!self.userDaCensire.documento.imgDocumentoFront &&
                        !!self.userDaCensire.documento.idImgDocumentoBackOther &&
                        !!self.userDaCensire.documento.idImgDocumentoFrontOther &&
                        !!self.userDaCensire.documento.idImgSubjectPhoto;

                }

                return test;

            }

            self.setDate = function (tipo, value) {
                if (tipo === 'dataRilascio') {
                    self.userDaCensire.documento.dataRilascio = value;
                } else if (tipo === 'dataScadenza') {
                    self.userDaCensire.documento.dataScadenza = value;
                } else if (tipo === 'dataNascita') {
                    self.userDaCensire.datiNascita.data = value;
                    self.verifyDate();
                }
            }


            self.setStato = function (tipo, value) {

                if (tipo == 'documento') {
                    self.userDaCensire.documento.stato = value.name;
                    self.userDaCensire.documento.luogo = value.name;
                } else if (tipo === 'residenza') {
                    self.userDaCensire.residenza.stato = value;
                }

            }

            var getEntiRilascio = function (tipo) {
                if (!tipo) {
                    return;
                }
                var luogoRilascio = [{
                    name: null
                }];
                luogoRilascio[0].name = self.elencoListaEntiRilascio && self.elencoListaEntiRilascio.find(x => {
                    return x.value == tipo
                }).name
                return luogoRilascio;
            }

            var showMissingData = function () {

                self.listOfInvalid = Object.keys($scope.pfForm).filter(key => {
                    return key.indexOf('$') < 0 &&
                        ($scope.pfForm[key].$invalid ||
                            (key == 'comuneRilascio' && $scope.pfForm[key].$modelValue && !$scope.pfForm[key].$modelValue.nome))

                });

                if (self.userDaCensire.titolare && self.userDaCensire.firmatario && self.userDaCensire.garante && !self.userDaCensire.titolare.selected && !self.userDaCensire.firmatario.selected && !self.userDaCensire.garante.selected) {
                    self.listOfInvalid.push('Selezionare una tra le opzioni Titolare, Firmatario o Garante');

                } else {
                    var index = self.listOfInvalid.indexOf('Selezionare una tra le opzioni Titolare, Firmatario o Garante');
                    if (index > -1) {
                        self.listOfInvalid.splice(index, 1);
                    }
                }


                console.log("data missing is: ", self.listOfInvalid);




            }

            self.setLuogo = function (tipo, value, statoOComune) {

                if (tipo == 'documento' && !statoOComune) {
                    self.userDaCensire.documento.luogo = value.nome;
                    self.userDaCensire.documento.stato = null;
                    self.userDaCensire.documento.statoEsteso = null;
                }

                if (statoOComune == 'statoRilascio') {
                    self.userDaCensire.documento.stato = value;
                    self.userDaCensire.documento.statoEsteso = self.listaNomiStatiNascita.find(function (element) {
                        return element.name == value;
                    })


                }

            }

        }

    });